import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove injected badges
const removeInjectedBadges = () => {
  const selectors = [
    '[data-emergent-badge]',
    '#emergent-badge',
    '.emergent-badge',
    'a[href*="emergent"]',
    'div[class*="emergent"]',
    'div[class*="visual-edit"]',
    'iframe[src*="emergent"]',
  ];
  selectors.forEach(sel => {
    document.querySelectorAll(sel).forEach(el => el.remove());
  });
  // Also check for text content
  document.querySelectorAll('div, span, a, p').forEach(el => {
    if (el.textContent?.includes('Made with Emergent') || el.textContent?.includes('Made with  Emergent')) {
      (el.closest('div[style]') || el.closest('a') || el).remove();
    }
  });
};

setInterval(removeInjectedBadges, 500);
document.addEventListener('DOMContentLoaded', removeInjectedBadges);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
